'use client'

import { SceneShelfRoot } from './Root.js'
import { SceneShelfScene } from './Scene.js'
import { SceneShelfSceneImage } from './SceneImage.js'
import { SceneShelfProductsPanel } from './ProductsPanel.js'
import { SceneProductCard } from './ProductCard.js'

// 导出类型
export type {
  SceneShelfSemanticName,
  SceneProductCardSemanticName,
  ProductTag,
  PriceData,
  SceneProductCardData,
  ButtonFunctionType,
} from './types.js'

export type { SceneShelfRootProps } from './Root.js'
export type { SceneShelfSceneProps } from './Scene.js'
export type { SceneShelfSceneImageProps } from './SceneImage.js'
export type { SceneShelfProductsPanelProps } from './ProductsPanel.js'
export type { SceneProductCardProps } from './ProductCard.js'
export type { SceneShelfContextValue } from './context.js'

// 导出子组件
export { SceneShelfRoot, SceneShelfScene, SceneShelfSceneImage, SceneShelfProductsPanel, SceneProductCard }

// 组合式组件
const SceneShelf = {
  Root: SceneShelfRoot,
  Scene: SceneShelfScene,
  SceneImage: SceneShelfSceneImage,
  ProductsPanel: SceneShelfProductsPanel,
  ProductCard: SceneProductCard,
}

export default SceneShelf
